import React, {useEffect} from 'react';
import {useDropzone} from 'react-dropzone';
import {Typography} from "@material-ui/core";
import {useTranslation} from "react-i18next";

function Basic(props) {
    const {acceptedFiles, getRootProps, getInputProps} = useDropzone();
    const {t, i18n} = useTranslation();

    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    useEffect(() => {
        props.onFiles(acceptedFiles);
    }, [acceptedFiles.length]);

    return (<Typography component={"div"} variant={"body1"}>
            <section style={{paddingTop: 35}} className="container">
                <div disabled={props.disabled} {...getRootProps({className: 'dropzone'})}>
                    <input {...getInputProps()} />
                    <p>{t("ui_pad_drag_drop")}</p>
                </div>
                <aside>
                    {acceptedFiles.length ?
                        <h4>Selected:</h4> : null}
                    <ul>{files}</ul>
                </aside>
            </section>
        </Typography>
    );
}

export default Basic;